import React, { useCallback, useEffect, useRef } from 'react';
import classNames from 'classnames';
import styles from './DiagnosticPackageTableRowGroup.module.css';

function DiagnosticPackageTableRowGroup({ className, style, children, diagPkgId, received, onView }) {
  const timeoutRef = useRef(null);
  const cancelViewed = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }, []);
  const markViewed = useCallback(() => {
    if (!received) {
      return;
    }

    cancelViewed();

    timeoutRef.current = setTimeout(() => {
      onView(diagPkgId);
      timeoutRef.current = null;
    }, 1000);
  }, [cancelViewed, onView, diagPkgId, received]);

  useEffect(() => cancelViewed, [cancelViewed]);

  return (
    <div
      role="rowgroup"
      className={classNames(styles.root, { [styles.highlighted]: received }, 'rt-tr-group', className)}
      onMouseEnter={markViewed}
      onMouseLeave={cancelViewed}
      style={style}
    >
      {children}
    </div>
  );
}

export default DiagnosticPackageTableRowGroup;
